import React, { useState } from 'react';

const SolutionTab = ({ id, title, isActive, onClick }) => {
  return (
    <div 
      className={`tab ${isActive ? 'active' : ''}`} 
      data-tab={id}
      onClick={() => onClick(id)}
    >
      {title}
    </div>
  );
};

const SolutionContent = ({ id, title, description, features, packageContent, pricing, disclaimer }) => {
  return (
    <div className={`tab-content ${id === 'project3' ? 'active' : ''}`} id={`${id}-content`} style={{ opacity: id === 'project3' ? 1 : 0 }}>
      <div className="solution-details">
        <h3>{title}</h3>
        <p>{description}</p>
        
        <ul className="feature-list">
          {features.map((feature, index) => (
            <li key={index}><i className="fas fa-check"></i> {feature}</li>
          ))}
        </ul>
        
        <h4>Paket İçeriği</h4>
        <ul className="feature-list">
          {packageContent.map((item, index) => (
            <li key={index}><i className={item.icon}></i> {item.text}</li>
          ))}
        </ul>
        
        <h4>Fiyat Bilgisi</h4>
        <ul className="feature-list">
          {pricing.map((price, index) => (
            <li key={index}><i className={price.icon}></i> {price.text}</li>
          ))}
        </ul>
        
        <p className="disclaimer">{disclaimer}</p>
        <a href="https://discord.gg/jF7k5rTp" target="_blank" rel="noopener noreferrer" className="btn primary">Satın Al (Discord)</a>
      </div>
    </div>
  );
};

const Solutions = () => {
  const [activeTab, setActiveTab] = useState('project3');

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const solutionData = {
    id: 'project3',
    title: 'Valorant HWID Spoofer',
    description: 'Artık Valorant\'tan yediğiniz donanım banları son buluyor! Size özel hazırladığımız HWID Spoofer aracıyla yepyeni bir sistem gibi oyuna geri dönün!',
    features: [
      'Windows 10 (Tüm sürümler)',
      'AMD & Intel işlemcilerle tam uyum',
      'HWID (donanım banı) tamamen temizlenir',
      'Oyuna sıfır ban iziyle yeniden girmeni sağlar',
      '%100 test edildi ve çalışıyor',
      'Güncel Vanguard uyumlu'
    ],
    packageContent: [
      { icon: 'fas fa-tools', text: 'HWID Spoofer' },
      { icon: 'fas fa-file-alt', text: 'Detaylı kullanım dökümanı' },
      { icon: 'fas fa-video', text: 'Videolu anlatım (isteğe bağlı)' },
      { icon: 'fas fa-headset', text: '7/24 Discord desteği' }
    ],
    pricing: [
      { icon: 'fas fa-key', text: 'Tek Seferlik Lisans: 500₺' },
      { icon: 'fas fa-sync', text: 'Sınırsız: 1000₺' }
    ],
    disclaimer: '💰 Spoofer çalışmazsa paranız iade edilir. Format atılmış ve BIOS güncellenmiş sisteme uygulanması gereklidir.'
  };

  return (
    <section id="projects" className="solutions">
      <div className="container">
        <div className="section-header">
          <h2>Popüler <span className="accent">Ürünlerimiz</span></h2>
          <p>En çok tercih edilen çözümlerimiz</p>
        </div>
        <div className="solutions-tabs">
          <div className="tabs-header">
            <SolutionTab 
              id={solutionData.id} 
              title="HWID Spoofer" 
              isActive={activeTab === solutionData.id}
              onClick={handleTabClick}
            />
          </div>
          <div className="tabs-content">
            <SolutionContent 
              id={solutionData.id}
              title={solutionData.title}
              description={solutionData.description}
              features={solutionData.features}
              packageContent={solutionData.packageContent}
              pricing={solutionData.pricing}
              disclaimer={solutionData.disclaimer}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions; 